import { Reveal } from "@/components/Reveal";

export const LegalLayout = ({ overline, title, updated, sections, testId }) => (
  <main className="pt-32 pb-28 px-6 lg:px-10" data-testid={testId}>
    <div className="max-w-3xl mx-auto">
      <Reveal>
        <p className="font-mono text-xs tracking-[0.2em] uppercase text-blue-500 mb-4">{overline}</p>
        <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tighter leading-none">{title}</h1>
        {updated && <p className="mt-4 font-mono text-xs text-slate-500">Dernière mise à jour : {updated}</p>}
      </Reveal>

      <div className="mt-16 space-y-12">
        {sections.map((s, i) => (
          <Reveal key={i} delay={Math.min(i * 0.04, 0.2)}>
            <section className="border-l border-slate-800 pl-6">
              <h2 className="font-heading font-bold text-lg text-white mb-3">
                <span className="font-mono text-blue-500 text-sm mr-3">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {s.heading}
              </h2>
              <div className="space-y-3">
                {s.body.map((p, j) => (
                  <p key={j} className="text-sm text-slate-400 leading-relaxed">{p}</p>
                ))}
              </div>
            </section>
          </Reveal>
        ))}
      </div>
    </div>
  </main>
);
